import React, {
  memo,
  PropsWithChildren,
  ReactNode,
  useMemo,
} from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import ButtonUI from "@/componentsUI/Button";
import { ChevronRightIcon } from "@/componentsUI/Icon";
import cs from "classnames";
import ListItem from "@/components/listItem/ListItem";
import { IFGameItem } from "@/api/apiRsp/IFHomeRsp";

interface listViewProps {
  title?: string;
  rightBtnTitle?: string;
  hideRightBtn?: boolean;
  minHeight?: number;
  list?: Array<any> | [];
  onClick?: (game: IFGameItem) => void;
  rightClick?: () => void;
  icon?: ReactNode | undefined;
  refresh?: boolean;
  isLazyLoading?: boolean;
  mobileGridLayout?: boolean;
  mobileMaxRows?: number;
  itemsPerRow?: number;
  isFirstCategory?: boolean; // 是否是第一个分类
}

const ListView = memo((Props: PropsWithChildren<listViewProps>) => {
  const {
    rightClick,
    mobileGridLayout = false,
    mobileMaxRows = 2,
    itemsPerRow = 3,
  } = Props || {};

  // 处理移动端网格数据限制
  const displayList = useMemo(() => {
    if (!Props.list) return [];

    if (mobileGridLayout) {
      const maxItems = mobileMaxRows * itemsPerRow;
      return Props.list.slice(0, maxItems);
    }

    return Props.list;
  }, [Props.list, mobileGridLayout, mobileMaxRows, itemsPerRow]);

  // 移动端网格布局渲染
  const renderMobileGrid = () => {
    return (
      <div className="mobile-grid-container">
        {displayList.map((item, index) => {
          // todo: ListItem DownloadGameCard
          // 在第一个分类的第2个位置（第一个游戏之后）插入下载引导item
          // if (isFirstCategory && index === 0) {
          //   return (
          //     <React.Fragment key={`fragment-${index}`}>
          //       <div key={index} className="mobile-grid-item">
          //         <ListItem data={{ ...item }} refresh={Props.refresh} />
          //       </div>
          //       <div key="download-item" className="mobile-grid-item">
          //         <DownloadGameCard />
          //       </div>
          //     </React.Fragment>
          //   );
          // }

          return (
            <div key={index} className="mobile-grid-item">
              <ListItem data={{ ...item }} refresh={Props.refresh} />
            </div>
          );
        })}
      </div>
    );
  };

  // 默认使用移动端 swiper 配置
  const mobileConfig = useMemo(
    () => ({
      spaceBetween: 8,
      slidesPerView: "auto" as const,
      freeMode: true,
      modules: [FreeMode],
      className: "mobile-game-swiper",
    }),
    []
  );

  return (
    <>
      {
        <div
          className={"list-view"}
          style={{ minHeight: Props.minHeight || 300 }}
        >
          {
            <>
              <div className={"list-top"}>
                <div className={"list-title"}>
                  {Props.icon && Props.icon}
                  {Props.title || ""}
                </div>
                <div className={"list-top-right"}>
                  {!Props.hideRightBtn && (
                    <div>
                      <ButtonUI
                        className={cs(
                          "swiper-view-btn",
                          "list-btn1",
                          "view-more-btn"
                        )}
                        type={"text"}
                        size={"mini"}
                        onClick={rightClick}
                      >
                        <span className="view-more-text">
                          {Props.rightBtnTitle || "More"}
                        </span>
                        <ChevronRightIcon
                          className="view-more-icon"
                        />
                      </ButtonUI>
                    </div>
                  )}
                </div>
              </div>
              {mobileGridLayout ? (
                renderMobileGrid()
              ) : (
                <Swiper {...mobileConfig}>
                  {Props?.list &&
                    Props.list.map((value, key) => {
                      return (
                        <SwiperSlide key={key} className="mobile-game-slide">
                          <ListItem
                            data={{ ...value }}
                            refresh={Props.refresh}
                          />
                        </SwiperSlide>
                      );
                    })}
                </Swiper>
              )}
            </>
          }
        </div>
      }
    </>
  );
});

ListView.displayName = "ListView";

export default ListView;
